export default __webpack_public_path__ + "static/media/2.66c683aa.png";